// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Q-zn","options":"AnswerScale_options__1xgru","selected":"AnswerScale_selected__ECjU9"};